
<template>
    <flex-element v-if="visible" :element-type="elementType">
        <div v-if="numberOfResults > -1" class="f-flex f-flex-row">
            <a-text-single-line
                v-bind="element(1)"
                single-line-text="There are "
                @element-updated="elementUpdated"
            />

            <div>
                {{ numberOfResults }}
            </div>

            <a-text-single-line
                v-bind="element(2)"
                single-line-text="result(s) that match your search criteria."
                @element-updated="elementUpdated"
            />
        </div>

        <placeholder v-else class="fc-placeholder" text="No search stats are currently available." />
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-smart';
import listenOnRootMixin from '@/mixins/listen-on-root';
import Placeholder from '@/components-user/placeholder';

export default {
    components: { Placeholder },
    mixins: [baseOrganism, listenOnRootMixin],

    props: {
        displayName: {
            type: String,
            default: 'Search Statistics',
        },

        name: {
            type: String,
            default: '',
        },

        activeIndex: {
            type: Number,
            default: -1,
        },

        tag: {
            type: String,
            default: 'div',
        },
    },

    data() {
        return {
            containerClassGroups: ['flexDirection'],
            numberOfResults: -1,
            visible: false,
        };
    },

    mounted() {
        this.listenOnRoot('flex::collection::search-totalResults', this.getNumberOfResults);
        this.listenOnRoot('flex::collection::query-refresh', this.resetStats);
        this.getNumberOfResults();
    },

    methods: {
        getNumberOfResults(data) {
            this.numberOfResults = data;
            this.visible = true;
        },
        resetStats() {
            this.visible = false;
            this.numberOfResults = -1;
        },
    },
};
</script>
